import React, { useEffect } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";

const TermsOfUse = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-neutral-50">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
        {/* Header */}
        <div className="flex items-center justify-between gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 rounded-full px-4 py-2 border border-gray-300 bg-white hover:bg-gray-50 text-sm"
          >
            <FiArrowLeft /> Geri
          </button>
          <div className="text-right text-xs text-gray-500">
            Son güncelleme: {new Date().toLocaleDateString("tr-TR")}
          </div>
        </div>

        <article className="rounded-2xl bg-white shadow-sm ring-1 ring-gray-100 p-5 sm:p-8 leading-relaxed text-gray-800">
          <header className="mb-6">
            <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">
              MESAFELİ SATIŞ SÖZLEŞMESİ VE WEB SİTESİ KULLANIM KOŞULLARI
            </h1>
          </header>

          {/* 1 */}
          <section id="taraflar" className="space-y-4">
            <h2 className="text-xl font-bold">1. TARAFLAR VE TANIMLAR</h2>

            <h3 className="font-semibold">1.1. TARAFLAR</h3>
            <p>
              İş bu üye sözleşmesi (bundan sonra “SÖZLEŞME” olarak anılacaktır),
              … adresinde mukim ARON … ile (bundan sonra “ARON” olarak
              anılacaktır) ARON’un sahibi olduğu ve hizmet sağladığı{" "}
              <strong>www.zenolearn.io</strong> adresi üzerinde yer alan Web
              Sitesi ve bu siteye bağlı dijital market uygulaması (bu sözleşmede
              “WEB SİTESİ ve/veya UYGULAMA” olarak anılacaktır) üzerinden
              etkinlik ve içerik hizmeti alımı yapmak üzere talepte bulunan …
              adresinde mukim … A.Ş. arasında (bu sözleşmede “MÜŞTERİ” veya
              “ÜYE” olarak anılacaktır) akdedilmiştir.
              
            </p>

            <h3 className="font-semibold">1.2. SÜRE VE TANIMLAR</h3>
            <p>
              1.2.1. İşbu sözleşme, imza tarihinden itibaren 1 (Bir) yıl için
              akdedilmiş olup toplam sözleşme süresi bir yılı doldurduktan sonra
              kendiliğinden veya sözleşme konusu etkinliğin gerçekleştirilip
              sona ermesini takip eden 7 (Yedi) günün sonunda kendiliğinden sona
              erer.
            </p>
            <p>
              1.2.2. Aşağıdaki terimler, sözleşmenin anlaşılabilir olmasını
              sağlamak amacıyla tanımlanmıştır: 
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>ZENOLEARN:</strong> (www.zenolearn.io) Müşterilerin
                kendi çevrimiçi ve mobil etkinlik alanlarını oluşturmasını,
                yönetmesini ve kullanmasını sağlayan etkinlik platformudur.
              </li>
              <li>
                <strong>MÜŞTERİ PLATFORMU:</strong> Müşteriler tarafından
                oluşturulan çevrimiçi ve mobil etkinlikler.
              </li>
              <li>
                <strong>KULLANICI:</strong> Web Sitesini ve/veya Uygulamayı
                ziyaret eden veya kullanan her birey ve ayrıca işbu sözleşmeyi
                imzalayan Müşteri/Üye.
              </li>
              <li>
                <strong>KULLANICI HESABI:</strong> Hizmetlere erişim için
                oluşturulan kimlik doğrulama sistemi.
              </li>
            </ul>
          </section>

          <hr className="my-6" />

          {/* 2 */}
          <section id="kullanim-kosullari" className="space-y-4">
            <h2 className="text-xl font-bold">
              2. KULLANIM KOŞULLARI, İÇERİĞİ VE BAĞLAYICILIĞI
            </h2>
            <p>
              ZenoLearn Kullanım Koşulları; ARON ve Kullanıcı arasında ZenoLearn
              Hizmetlerinin kullanımına ilişkin bağlayıcı bir sözleşmedir.
              ZenoLearn üzerinde yer alan ve Müşteri tarafından oluşturulan
              içeriklerden ARON sorumlu değildir. 
            </p>
            <p>Kullanıcı bu koşullarla aşağıdakileri kabul eder:</p>
            <ol className="list-decimal pl-6 space-y-2">
              <li>
                Web sitesini/uygulamayı ziyaret ve kullanım, koşulların
                tamamının kabulü anlamına gelir.
              </li>
              <li>
                Herhangi bir hizmete kayıt, yürürlükteki tüm koşullardan
                haberdar olunduğu anlamına gelir.
              </li>
              <li>
                Koşullar kabul edilmiyorsa hizmetler kullanılmamalıdır; kullanım
                hukuki sözleşme teşkil eder.
              </li>
              <li>
                Koşullar kısmen kabul edilemez; kısmi ret halinde hizmetler
                kullanılamaz.
              </li>
            </ol>
          </section>

          <hr className="my-6" />

          {/* 3 */}
          <section id="kullanim-sekli" className="space-y-4">
            <h2 className="text-xl font-bold">3. KULLANIM ŞEKLİ</h2>

            <h3 className="font-semibold">3.1. Kullanıcı Hesabı</h3>
            <p>
              Bazı hizmetlere erişim için Web Sitesine kayıt ve kullanıcı hesabı
              oluşturulması zorunludur. Mobil uygulamalar sanal marketlerden
              indirilir ve kullanıcı şifresiyle işlemler yapılır.
              
            </p>

            <h3 className="font-semibold">
              3.2. Hesaplara; Rollere ve İzinlere Erişim
            </h3>
            <p>
              Müşteri üçüncü kişileri davet edebilir; atanan yetkilerden ve
              hesaptaki tüm faaliyetlerden Müşteri sorumludur. Bilgilerin doğru
              ve eksiksiz verilmesi zorunludur. 
            </p>

            <h3 className="font-semibold">3.3. Hesap Sahipliği</h3>
            <p>
              Platformun ve hesabın sahibi; ARON kayıtlarında yer alan ve
              faturada görünen kişi/kuruluş kabul edilir. Uyuşmazlık halinde
              ARON hesabı askıya alma hakkını saklı tutar.
              
            </p>
          </section>

          <hr className="my-6" />

          {/* 4 */}
          <section id="taahhutler" className="space-y-3">
            <h2 className="text-xl font-bold">4. TAAHHÜTLER</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>
                Kullanıcı uluslararası yaptırım listelerinde bulunmadığını
                taahhüt eder.
              </li>
              <li>
                ARON, web sitesi kullanım amacı ve içeriği konusunda tavsiye/
                danışmanlık vermez.
              </li>
              <li>
                Web Sitesinde yer alan tasarım, görsel, kod vb. tüm materyaller
                ARON’a aittir.
              </li>
              <li>
                Müşteri kendi oluşturduğu içeriğin doğruluğundan ve üçüncü kişi
                haklarını ihlal etmemesinden sorumludur.
              </li>
              <li>
                KVKK dâhil mevzuat kapsamında gerekli izin/onayların alınması
                Müşteri’nin sorumluluğundadır.
              </li>
              <li>
                Kullanıcı adı/şifreyle yapılan tüm işlemler Kullanıcı
                sorumluluğundadır; içerik ve verilerin yüklenmesi Müşteriye
                aittir.
              </li>
              <li>
                İçeriğin barındırılması/iletilmesi yöntemleri ARON’un
                takdirindedir.
              </li>
              <li>Kopyalama, değiştirme, tersine mühendislik vb. yasaktır.</li>
              <li>
                Haklar; karalayıcı, tehditkâr, ırkçı, yanıltıcı vb. şekilde
                kullanılamaz.
              </li>
              <li>ARON’un itibarını zedeleyici eylemlerden kaçınılır.</li>
              <li>
                Başkalarının mahremiyetine müdahale ve kişisel veri toplama/
                yayınlama yasaktır.
              </li>
              <li>
                Lisanslı içerik/hizmetlerin satışı veya ticari istismarı
                yasaktır.
              </li>
              <li>
                ARON, sözleşme süresince teknik destek ve teslimat gerektiren
                hususlarda ücretsiz hizmet sağlar. 
              </li>
            </ol>
          </section>

          <hr className="my-6" />

          {/* 5 */}
          <section id="fikri-mulkiyet" className="space-y-3">
            <h2 className="text-xl font-bold">5. FİKRİ MÜLKİYET HAKLARI</h2>
            <p>
              Her türlü eser, kod, tasarım, veri, marka vb. içerikler ve bunlara
              ilişkin haklar ARON’a aittir. Kullanıcıya yalnızca münhasır
              olmayan, devredilemez bir kullanım lisansı verilebilir. Bu
              lisanslar ARON tarafından geri alınabilir.
              
            </p>
          </section>

          <hr className="my-6" />

          {/* 6 */}
          <section id="gizlilik" className="space-y-3">
            <h2 className="text-xl font-bold">6. GİZLİLİK</h2>
            <p>
              Hizmetlerin bazı bölümleri kişisel verilerin verilmesini ve/veya
              işlenmesini gerektirebilir. KVKK kapsamındaki imha talepleri ARON
              tarafından <strong>48 saat</strong> içinde yerine getirilir.
              
            </p>
          </section>

          <hr className="my-6" />

          {/* 7 */}
          <section id="ucretler" className="space-y-3">
            <h2 className="text-xl font-bold">7. HİZMET ÜCRETLERİ</h2>

            <h3 className="font-semibold">7.1. Ücretli Hizmetler</h3>
            <p>
              Bazı hizmetler ücrete tabidir; ücret değişiklikleri duyurulabilir.
              Tüm fiyatlar vergiler hariçtir ve vergiler Kullanıcı tarafından
              ödenir. Ücretler toplam kullanıcı sayısına göre belirlenebilir.
              
            </p>

            <h3 className="font-semibold">7.2. Faturalar</h3>
            <p>
              Ödemeler yapıldığında e-fatura düzenlenir ve hesap erişimi açılır.
              Ödememe halinde hizmetler askıya alınabilir; 30 gün gecikmede
              sözleşme bedelinin %10’u cezai şart uygulanır.
              
            </p>

            <h3 className="font-semibold">7.3. Ücretli Etkinlikler</h3>
            <p>
              ARON, ücretli etkinlik bilet satışında ödeme sağlayıcılarla
              çalışabilir; esaslar ayrı sözleşmelerle belirlenir.
              
            </p>
          </section>

          <hr className="my-6" />

          {/* 8 */}
          <section id="iptal" className="space-y-3">
            <h2 className="text-xl font-bold">8. İPTAL</h2>

            <h3 className="font-semibold">
              8.1. Kullanıcı Tarafından İptaller ve Sisteme Kabul
            </h3>
            <p>
              Giriş talepleri Müşteri onayıyla aktif olur. Kullanıcı hesabını
              dilediği an durdurabilir; iptal ödenmiş dönem sonunda geçerli
              olur. Müşteri kullanıcıyı pasif yapabilir.
              
            </p>

            <h3 className="font-semibold">8.2. İhlaller ve ARON İptalleri</h3>
            <p>
              Koşullara aykırılık veya ödememe halinde ARON, hesap ve hizmetleri
              askıya alabilir/iptal edebilir. 48 saat içinde giderilmeyen
              ihlallerde iptal hakkı saklıdır. 
            </p>

            <h3 className="font-semibold">
              8.3. Veri, İçerik ve Kapasite Kaybı
            </h3>
            <p>
              İptal; içerik/veri kaybına yol açabilir. ARON yedekleme ve
              saklamadan sorumlu değildir; verilerin yedeklenmesi Kullanıcının
              sorumluluğudur. 
            </p>
          </section>

          <hr className="my-6" />

          {/* 9 */}
          <section id="ucuncu-taraf" className="space-y-3">
            <h2 className="text-xl font-bold">9. ÜÇÜNCÜ TARAF HİZMETLERİ</h2>
            <p>
              ARON; üçüncü taraf uygulamaları, ödeme sağlayıcıları ve lisanslı
              içerikleri platform üzerinden kullanıma açabilir; bu hizmetlerden
              doğan risk ve sorumluluk Kullanıcıya aittir. ARON dilediğinde bu
              hizmetleri askıya alabilir veya kaldırabilir.
              
            </p>
          </section>

          <hr className="my-6" />

          {/* 10 */}
          <section id="uygunsuz-davranis" className="space-y-3">
            <h2 className="text-xl font-bold">
              10. UYGUNSUZ DAVRANIŞLAR VE TACİZ
            </h2>
            <p>
              Hukuka aykırı veya uygunsuz davranışların ARON’a bildirilmesi
              zorunludur; ARON, platforma erişimi engelleme dâhil caydırıcı
              yaptırımlar uygulayabilir. 
            </p>
          </section>

          <hr className="my-6" />

          {/* 11 */}
          <section id="telif" className="space-y-3">
            <h2 className="text-xl font-bold">11. TELİF HAKLARI</h2>
            <p>
              Telif ihlali bildirimlerinde ARON, bildirimde bulunan tarafa bilgi
              verebilir; içerik kaldırma ve/veya hesabı askıya alma/ iptal etme
              hakkını saklı tutar. 
            </p>
          </section>

          <hr className="my-6" />

          {/* 12 */}
          <section id="iliski-sorumluluk" className="space-y-3">
            <h2 className="text-xl font-bold">
              12. İLİŞKİ VE SORUMLULUK REDDİ
            </h2>
            <p>
              Kullanım Koşulları; taraflar arasında ortaklık, işveren-çalışan
              vb. ilişki doğurmaz. ARON, kullanıcı içeriklerinin yayıncısı
              değildir ve içeriklerden doğan zararlardan sorumlu tutulamaz.
              Üçüncü taraf hizmetlerle kurulan ilişkilerin sonuçları garanti
              edilmez. 
            </p>
          </section>

          <hr className="my-6" />

          {/* 13 */}
          <section id="mucbir-sebep" className="space-y-3">
            <h2 className="text-xl font-bold">13. MÜCBİR SEBEPLER</h2>
            <p>
              İnternet/elektrik arızaları, doğal afetler, savaş, terör vb.
              mücbir sebeplerden doğan erişim sorunlarında ARON sorumlu değildir
              ve hiçbir tazmin yükümlülüğü doğmaz. 
            </p>
          </section>

          <hr className="my-6" />

          {/* 14 */}
          <section id="degisiklikler" className="space-y-3">
            <h2 className="text-xl font-bold">
              14. DEĞİŞİKLİKLER VE GÜNCELLEŞTİRMELER
            </h2>
            <p>
              ARON, hizmetlerini ve fiyatlarını dilediği zaman değiştirme/askıya
              alma/sonlandırma ve koşulları güncelleme hakkını saklı tutar; ek
              ücret gerektiren değişiklikler etkinleştirilmeden önce
              bildirilecektir. 
            </p>
          </section>

          <hr className="my-6" />

          {/* 15 */}
          <section id="uygulanacak-hukuk" className="space-y-3">
            <h2 className="text-xl font-bold">
              15. UYGULANACAK KANUN, YARGI YETKİSİ, YETKİLİ MAHKEME
            </h2>
            <p>
              Kullanım Koşulları ve bunlardan doğan tüm uyuşmazlıklarda Türkiye
              Cumhuriyeti hukuku uygulanır; İstanbul Mahkemeleri ve İcra
              Müdürlükleri yetkilidir. 
            </p>
          </section>

          <hr className="my-6" />

          {/* 16 */}
          <section id="tebligat" className="space-y-3">
            <h2 className="text-xl font-bold">16. BİLDİRİM VE TEBLİGATLAR</h2>
            <p>
              Kullanıcı hesabı açılırken bildirilen e-posta ve adreslere yapılan
              bildirim/tebligatlar geçerlidir. 
            </p>
          </section>

          <hr className="my-6" />

          {/* 17 */}
          <section id="butunluk" className="space-y-3">
            <h2 className="text-xl font-bold">
              17. ANLAŞMANIN BÜTÜNLÜĞÜ, HÜKÜMLERİN BÖLÜNEBİLİRLİĞİ VE FERAGAT
            </h2>
            <p>
              Bu Koşullar, taraflar arasındaki anlaşmanın bütününü teşkil eder.
              Geçersiz sayılan bir hüküm diğer hükümlerin geçerliliğini
              etkilemez. 
            </p>
          </section>

          <hr className="my-6" />

          {/* 18 */}
          <section id="devir" className="space-y-3">
            <h2 className="text-xl font-bold">18. DEVİR YETKİSİ</h2>
            <p>
              ARON, yazılı bildirimle bu Koşullardaki hak ve yükümlülüklerini
              üçüncü kişilere devredebilir. Müşteri/Kullanıcı ise ARON’un yazılı
              izni olmadan devir yapamaz.
            </p>
          </section>

          <hr className="my-6" />

          {/* 19 */}
          <section id="yururluk" className="space-y-3">
            <h2 className="text-xl font-bold">19. YÜRÜRLÜK</h2>
            <p>
              İşbu Kullanım Koşulları/Sözleşme 18 madde ve 9 sayfadan ibaret
              olup yayınlanarak yürürlüğe girmiştir. Müşteri ile ARON arasında
              ıslak imzalı bir versiyon varsa imza tarihi yürürlük tarihidir.
              
            </p>
          </section>

          <footer className="mt-10 pt-6 border-t border-gray-100 text-sm text-gray-600">
            <p>
              Sorularınız için{" "}
              <a
                href="mailto:info@zenolearn.io"
                className="text-emerald-600 underline"
              >
                info@zenolearn.io
              </a>{" "}
              adresine yazabilirsiniz.
            </p>
            <div className="mt-3 flex flex-wrap gap-3 text-sm">
              <Link to="/legal/privacy" className="underline text-gray-700">
                KVKK Gizlilik Politikası
              </Link>
              <span className="opacity-40">•</span>
              <Link
                to="/legal/clarification"
                className="underline text-gray-700"
              >
                Aydınlatma Metni
              </Link>
            </div>
          </footer>
        </article>
      </div>
    </main>
  );
};

export default TermsOfUse;
